import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// components
import BaseTrigger from 'triggers/BaseTrigger';

const baseString = 'vra-export-options-menu';
const OptionDeviceTrigger = ({
  driveDevices,
  onClickDeviceOption
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    'vra-popover-menu': true
  });

  return (
    <div>
      {driveDevices.map(device => {
        return (
          <li 
            key={device.id}
            className={'vra-popover-menu__item'}>
            <BaseTrigger
              className={classString}
              content= {device.name}
              dataTestId={baseString}
              handler={() => onClickDeviceOption(device)} />
          </li>
        );
      })}
    </div>
      
  );
};
OptionDeviceTrigger.propTypes = {
  className: PropTypes.string,
  driveDevices: PropTypes.arrayOf(PropTypes.shape({
    description: PropTypes.string,
    deviceModelId: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string
  })),
  onClickDeviceOption: PropTypes.func.isRequired,
  onClickSendToDrive: PropTypes.func.isRequired
};
export default OptionDeviceTrigger;
